module.exports = __webpack_public_path__ + "static/media/Polygon.b017d41e.svg";